import { render, staticRenderFns } from "./OrdenDeMeritoPage.vue?vue&type=template&id=03edb98a"
import script from "./OrdenDeMeritoPage.js?vue&type=script&lang=js&external"
export * from "./OrdenDeMeritoPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports